export function PriorityPill({ priority, label, compact }) {
  return (
    <span className={"pill " + (priority || "").toLowerCase()}
          title={compact && label ? priority + " — " + label : undefined}>
      {compact ? priority : priority + (label ? " — " + label : "")}
    </span>
  );
}

export function StatusPill({ status }) {
  return <span className={"pill status " + String(status).toLowerCase()}>{status}</span>;
}
